var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-portlet-base',{attrs:{"title":_vm.title,"tooltip":_vm.tooltip,"showError":_vm.error,"loading":_vm.localLoading,"footer":_vm.footer,"simple":""}},[_c('ui-chart-pie',{ref:"chart",attrs:{"data":_vm.chartData,"chart-title":_vm.title,"loading":_vm.localLoading,"height":_vm.height,"noDataMessage":_vm.noDataMessage,"donut":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }